import React from 'react';
import { useFela } from 'react-fela';
import { useOptions } from '../../../OptionsContext';
import platform, { OS_TYPES } from '../../../../player/utils/platform';

const restoreButtonRules = ({ theme, isMobile }) => ({
  cursor: 'pointer',
  marginTop: '-3px',
  opacity: theme.opacity.enabled,
  transition: theme.transition.default,
  willChange: 'opacity',
  ':hover': {
    opacity: theme.opacity.hovered,
  },
  extend: [
    {
      condition: isMobile,
      style: {
        opacity: theme.opacity.hovered,
      },
    },
  ],
});

function RestoreMiniPlayer() {
  const isMobile = [OS_TYPES.IOS, OS_TYPES.ANDROID].includes(platform.os);
  const options = useOptions();
  const { css } = useFela({ isMobile });

  if (!options.restoreFromMiniPlayer) {
    return null;
  }

  return (
    <div
      onClick={options.restoreFromMiniPlayer}
      className={css(restoreButtonRules)}
    >
      <svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="7" y="6" width="12" height="9" rx="1" fill="white" />
        <rect x="0.5" y="0.5" width="13" height="9.83871" rx="0.5" stroke="white" />
        <path
          d="M2.14689 2.43762C2.11572 2.26585 2.26574 2.11583 2.43751 2.147L4.96133 2.60497C5.1598 2.64099
          5.2361 2.88511 5.09347 3.02773L3.02763 5.09358C2.885 5.23621 2.64088 5.1599 2.60487 4.96144L2.14689 2.43762Z"
          fill="white"
        />
        <path d="M3.15723 3.18359L4.89784 4.9242" stroke="white" strokeLinecap="round" />
      </svg>
    </div>
  );
}

export default React.memo(RestoreMiniPlayer);
